import React from 'react'

import { IService } from '../interfaces/IService'

export const ServiceItem = ({
  title,
  service,
  slug,
  featuredImage,
}: IService) => {
  let excerptList = ''

  if (service) {
    excerptList = service.excerptList!
  }

  return (
    <li>
      <a
        className="service-link w-full grid gap-8 grid-cols-[auto,1fr] py-8"
        href={`/sluzba/${slug}`}
      >
        {featuredImage!.node!.sourceUrl! && (
          <img src={featuredImage!.node!.sourceUrl} alt={title} width={93} />
        )}

        <div className="grid content-start gap-2 text-primary">
          <h3 className="font-semibold text-2xl">{title}</h3>

          <div dangerouslySetInnerHTML={{ __html: excerptList! }} />
        </div>
      </a>
    </li>
  )
}
